import {Options, Vue} from "vue-class-component";
import Modal from "@/components/Modal.vue";
@Options({
  emits: ['update:show', 'confirm', 'close'],
  data: function () {
    return {
      showCities: false,
      firstColumnCities: [],
      secondColumnCities: [],
      acceptedTerms: false
    }
  },
  components: {
    Modal
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isFormInvalid() {
      return false;
    }
  },
  watch: {
    show(newValue: any) {
      if(newValue) {
        this.acceptedTerms = false;
      }
    }
  },
  methods: {
    close() {
      this.showCities = false;
      this.$emit('update:show', false);
      this.$emit('close', true);
    },
  },
})
export default class CopyrightTermsModal extends Vue {

}
